import React from "react";

export function useWizard({ steps, initialStepId }) {
  const initialIndex = React.useMemo(() => {
    if (!initialStepId) return 0;
    const idx = steps.findIndex((s) => s.id === initialStepId);
    return idx >= 0 ? idx : 0;
  }, [steps, initialStepId]);

  const [currentStepIndex, setCurrentStepIndex] = React.useState(initialIndex);

  const currentStep = steps[currentStepIndex];

  const canGoBack = currentStepIndex > 0;
  const canGoNext = currentStepIndex < steps.length - 1;
  const isLastStep = currentStepIndex === steps.length - 1;

  function goToIndex(index) {
    if (index < 0) return;
    if (index >= steps.length) return;
    setCurrentStepIndex(index);
  }

  function goToId(id) {
    const idx = steps.findIndex((s) => s.id === id);
    if (idx >= 0) setCurrentStepIndex(idx);
  }

  function back() {
    if (!canGoBack) return;
    setCurrentStepIndex((prev) => Math.max(0, prev - 1));
  }

  function next() {
    if (!canGoNext) return;
    setCurrentStepIndex((prev) => Math.min(steps.length - 1, prev + 1));
  }

  return {
    steps,
    currentStepIndex,
    currentStep,
    canGoBack,
    canGoNext,
    isLastStep,
    goToIndex,
    goToId,
    back,
    next,
  };
}
